import React from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { AddressList } from '@qbe/dfc-services';
import { ADDRESS_FIELD_MAPS } from 'components/AddressSearch/addressHelpers';
import { AddressType } from 'components/AddressSearch/addressTypes';
import type { FormDataType } from 'contexts/FormProvider';

const useAddressDefaults = (type: AddressType, form: UseFormReturn<FormDataType>) => {
  const { getValues } = form;

  const getAddressDefaults = React.useCallback(() => {
    const f = ADDRESS_FIELD_MAPS[type];
    const isManual = getValues(f.isManualAddress) as boolean;
    const addressObject = getValues(f.addressObject) as AddressList | null;

    const defaultManualAddress = isManual
      ? {
          streetAddress1: (getValues(f.streetAddress) as string) ?? '',
          city: (getValues(f.suburb) as string) ?? '',
          state: (getValues(f.state) as string) ?? '',
          postcode: (getValues(f.postcode) as string) ?? '',
          country: (getValues(f.country) as string) ?? '',
          partialAddress: '',
        }
      : null;

    return {
      isManual,
      addressObject,
      defaultManualAddress,
    };
  }, [getValues, type]);

  return getAddressDefaults;
};

export default useAddressDefaults;
